import { getSafe } from '@/plugins/globals.plugin'
import {
  // getParametersValue,
  // toBase64,
  arrayBufferToString
  // stringToArrayBuffer,
  // fromBase64,
  // nearestPowerOf2,
  // clearProps
} from 'pvutils'
const request = require('superagent')

class HSM {
  constructor ({ baseUrl, authToken = null }) {
    this.baseUrl = baseUrl
    this.authToken = authToken
  }

  netTools (body) {
    const url = `${this.baseUrl}/net_tool`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }
    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .end((err, res) => {
          if (err) {
            const errorJSON = JSON.parse(res.text)
            return reject(errorJSON)
          }
          return resolve(res.text)
        })
    })
  }

  getKcvOrCmac (body) {
    const url = `${this.baseUrl}/eft_get_kcv`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }
    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .end((err, res) => {
          if (err) {
            const errorJSON = JSON.parse(res.text)
            return reject(errorJSON)
          }
          return resolve(res.text)
        })
    })
  }

  async doBackup (form, param) {
    return new Promise((resolve, reject) => {
      try {
        param = Object.assign(param || {}, {
          'hsm-authorization': this.authToken
        })

        // var form = document.createElement("form");
        form.setAttribute('method', 'post')
        form.setAttribute('target', 'hidden-form')
        form.setAttribute('enctype', 'text/plain')
        form.setAttribute('action', `${this.baseUrl}/get_backup`)

        const hiddenField = document.createElement('input')
        hiddenField.setAttribute('type', 'hidden')
        hiddenField.setAttribute('name', 'json')
        hiddenField.setAttribute('value', JSON.stringify(param))

        form.appendChild(hiddenField)

        document.body.appendChild(form)
        form.submit()
        resolve()
      } catch (err) {
        return reject(err)
      }
    })
  }

  getLog ({ start = 0, end = 5000 }) {
    const url = `${this.baseUrl}/get_log`
    const headers = { Authorization: `HSM ${this.authToken}` }
    const body = { start, end }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }

          const body = res.text
          const lines = body.split('\n')

          return resolve(lines)
        })
    })
  }

  getLogMon () {
    const url = `${this.baseUrl}/log_mon`
    const headers = { Authorization: `HSM ${this.authToken}` }
    return request.get(url).set(headers)
    // return new Promise((resolve, reject) => {
    //   request
    //     .post(url)
    //     .set(headers)
    //     .end((err, res) => {
    //       if (err) {
    //         const errBody = getSafe(() => err.response.body, err.message)
    //         return reject(errBody)
    //       }
    //       return resolve(res)
    //     })
    // })
  }

  getFirmwareUpdate () {
    const url = `${this.baseUrl}/upack_push`
    const headers = { Authorization: `HSM ${this.authToken}` }
    const auth = { 'HSM-Upload-CSP': '' }
    return request
      .post(url)
      .set(headers)
      .set(auth)

    // return new Promise((resolve, reject) => {
    //   request
    //     .post(url)
    //     .set(headers)
    //     .set(auth)
    //     .end((err, res) => {
    //       if (err) {
    //         const errBody = getSafe(() => err.response.body, err.message)
    //         return reject(errBody)
    //       }
    //       return resolve(res)
    //     })
    // })
  }

  getRestore () {
    const url = `${this.baseUrl}/restore_backup`
    const headers = { Authorization: `HSM ${this.authToken}` }
    // const auth = { 'HSM-Upload-CSP': `${pwd}:${restore}` }
    return request.post(url).set(headers)
    // return new Promise((resolve, reject) => {
    //   request
    //     .post(url)
    //     .set(headers)
    //     .end((err, res) => {
    //       if (err) {
    //         const errBody = getSafe(() => err.response.body, err.message)
    //         return reject(errBody)
    //       }
    //       return resolve(res)
    //     })
    // })
  }

  getSessions () {
    const url = `${this.baseUrl}/sessions`
    const headers = { Authorization: `HSM ${this.authToken}` }

    return new Promise((resolve, reject) => {
      request
        .get(url)
        .set(headers)
        .end((err, res) => {
          if (err) return reject(err)

          const body = res.text
          let lines = body.split('\n')
          lines = lines.map(line => {
            try {
              const json = JSON.parse(line)
              if (json) return json
            } catch (err) {
              // console.log(err)
            }
            return null
          })
          return resolve(lines)
        })
    })
  }

  createBlob ({ name, file }) {
    const url = `${this.baseUrl}/create_blob`
    const headers = {
      Authorization: `HSM ${this.authToken}`,
      'Content-Type': 'application/octet-stream',
      'HSM-Upload-CSP': name
    }
    return request
      .post(url)
      .set(headers)
      .send(file)

    // return new Promise((resolve, reject) => {
    //   request
    //     .post(url)
    //     .set(headers)
    //     .send(file)
    //     .end((err, res) => {
    //       if (err) {
    //         const errBody = getSafe(() => err.response.body, err.message)
    //         return reject(errBody)
    //       }
    //       return resolve(res)
    //     })
    // })
  }

  newX509AuthSa ({ usr, file }) {
    const url = `${this.baseUrl}/new_x509_auth_sa`
    const headers = {
      Authorization: `HSM ${this.authToken}`,
      'Content-Type': 'application/octet-stream',
      'HSM-Upload-CSP': usr
    }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(file)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            return reject(errBody)
          }
          return resolve(res)
        })
    })
  }

  getUsers () {
    const url = `${this.baseUrl}/list_usrs`
    const headers = { Authorization: `HSM ${this.authToken}` }

    return new Promise((resolve, reject) => {
      request
        .get(url)
        .set(headers)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }
          return resolve(res.body.usr)
        })
    })
  }

  getKeys () {
    const url = `${this.baseUrl}/list_objs`
    const headers = { Authorization: `HSM ${this.authToken}` }

    return new Promise((resolve, reject) => {
      request
        .get(url)
        .set(headers)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }
          return resolve(res.body.obj)
        })
    })
  }

  exportObject ({ obj }) {
    const url = `${this.baseUrl}/obj_exp`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send({ obj })
        .responseType('arraybuffer')
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }
          return resolve(res.body)
        })
    })
  }

  exportP8 (body) {
    const url = `${this.baseUrl}/p8_exp`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }
    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(errBody)
            return reject(errorJSON)
          }
          return resolve(res.text)
        })
    })
  }

  exportP12 (body) {
    const url = `${this.baseUrl}/p12_exp`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .responseType('arraybuffer')
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }
          return resolve(res.body)
        })
    })
  }

  p10CSR (body) {
    const url = `${this.baseUrl}/p10_csr`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(errBody)
            return reject(errorJSON)
          }
          return resolve(res.text)
        })
    })
  }

  kekWrap (body) {
    const url = `${this.baseUrl}/kek_wrap`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `HSM ${this.authToken}`
    }

    return new Promise((resolve, reject) => {
      request
        .post(url)
        .set(headers)
        .send(body)
        .responseType('arraybuffer')
        .end((err, res) => {
          if (err) {
            const errBody = getSafe(() => err.response.body, err.message)
            const errorJSON = JSON.parse(arrayBufferToString(errBody))
            return reject(errorJSON)
          }
          return resolve(res.body)
        })
    })
  }
}

/**
 * Creating class functions based in a list
 */
export const HSM_API = [
  {
    name: 'login',
    type: 'POST',
    path: '/auth',
    body: { usr: null, pwd: null, otp: null },
    public: true
  },
  {
    name: 'logout',
    type: 'POST',
    path: '/close',
    body: {}
  },
  {
    name: 'getP11Info',
    type: 'GET',
    path: '/hsm_p11_info'
  },
  {
    name: 'getCopyrightInfo',
    type: 'GET',
    path: '/copyright_info',
    responseRoot: 'info'
  },
  {
    name: 'getProbe',
    type: 'GET',
    path: '/probe'
  },
  {
    name: 'getLoadedMods',
    type: 'GET',
    path: '/loaded_mods'
  },
  {
    name: 'getSysHealth',
    type: 'GET',
    path: '/sys_health'
  },
  {
    name: 'getPwdSecPolicy',
    type: 'GET',
    path: '/get_pwd_sec_policy'
  },
  {
    name: 'setPwdSecPolicy',
    type: 'POST',
    path: '/set_pwd_sec_policy',
    body: {
      max_inv_logins: 0,
      expiration: 0,
      min_len: 8,
      min_special: 0,
      min_upper: 0,
      min_lower: 0
    }
  },
  {
    name: 'getLogSize',
    type: 'GET',
    path: '/log_size',
    responseRoot: 'size'
  },
  {
    name: 'getNetInfo',
    type: 'GET',
    path: '/net_info'
  },
  {
    name: 'getIpFilter',
    type: 'GET',
    path: '/get_ip_filter'
  },
  {
    name: 'getLogCacheState',
    type: 'GET',
    path: '/log_cache_state',
    responseRoot: 'state'
  },
  {
    name: 'getAtokenList',
    type: 'GET',
    path: '/atoken_list'
  },
  {
    name: 'getListUsers',
    type: 'GET',
    path: '/list_usrs',
    responseRoot: 'usr'
    // paginate: true,
    // sort: true,
    // query: { page: 1, max: 10 }
  },
  {
    name: 'getListObjects',
    type: 'GET',
    path: '/list_objs',
    responseRoot: 'obj'
  },
  {
    name: 'getStatInfo',
    type: 'POST',
    path: '/stat_info',
    body: { info: 9 }
  },
  {
    name: 'getAcl',
    type: 'POST',
    path: '/get_acl',
    body: { usr: null }
  },
  {
    name: 'updateAcl',
    type: 'POST',
    path: '/update_acl',
    body: {
      usr: null,
      acl: 0
    }
  },
  {
    name: 'setIpFilter',
    type: 'POST',
    path: '/set_ip_filter',
    body: {
      enabled: 0
    }
  },
  {
    name: 'addIpFilter',
    type: 'POST',
    path: '/add_ip_filter',
    body: {
      usr: null,
      addr: null
    }
  },
  {
    name: 'delIpFilter',
    type: 'POST',
    path: '/del_ip_filter',
    body: {
      usr: null,
      addr: null
    }
  },
  {
    name: 'setLogCache',
    type: 'POST',
    path: '/set_log_cache',
    body: {
      enabled: 1
    }
  },
  {
    name: 'truncateLog',
    type: 'POST',
    path: '/truncate_log',
    body: {}
  },
  {
    name: 'changePassword',
    type: 'POST',
    path: '/change_pwd',
    body: {
      pwd: null
    }
  },
  {
    name: 'replNodeMsg',
    type: 'POST',
    path: '/repl_node_msg',
    body: {
      op: 0,
      peer: null
    }
  },
  {
    name: 'replPulse',
    type: 'POST',
    path: '/repl_pulse',
    body: {}
  },
  {
    name: 'unpackPush',
    type: 'POST',
    path: '/upack_push',
    body: {
      upack_id: null
    }
  },
  {
    name: 'genRand',
    type: 'POST',
    path: '/gen_rand',
    body: {
      len: 0
    }
  },
  {
    name: 'createUser',
    type: 'POST',
    path: '/create_usr',
    body: {
      usr: null,
      pwd: null,
      acl: 0
    }
  },
  {
    name: 'deleteUser',
    type: 'POST',
    path: '/delete_usr',
    body: {
      usr: null
    }
  },
  {
    name: 'blockUser',
    type: 'POST',
    path: '/block_usr',
    body: {
      usr: 0,
      op: 0
    }
  },
  {
    name: 'getNsAuth',
    type: 'POST',
    path: '/get_nsauth',
    body: {
      usr: null
    }
  },
  {
    name: 'delAuthSa',
    type: 'POST',
    path: '/del_auth_sa',
    body: {
      usr: null,
      sa: 0
    }
  },
  {
    name: 'newOathAuthSa',
    type: 'POST',
    path: '/new_oath_auth_sa',
    body: {
      usr: null,
      key: null,
      type: 1,
      trunc_offset: 16,
      time_step: 30,
      T0: 0
    }
  },
  {
    name: 'setTlsBundle',
    type: 'POST',
    path: '/set_tls_bundle',
    body: {
      key: null,
      cert: null
    }
  },
  {
    name: 'aTokenIssue',
    type: 'POST',
    path: '/atoken_issue',
    body: {
      expiration: -1
    }
  },
  {
    name: 'aTokenRevoke',
    type: 'POST',
    path: '/atoken_revoke',
    body: {
      atoken: null
    }
  },
  {
    name: 'listUserTrust',
    type: 'POST',
    path: '/list_usr_trust',
    body: {
      op: 0,
      usr: null
    }
  },
  {
    name: 'delObject',
    type: 'POST',
    path: '/del_obj',
    body: {
      obj: null
    }
  },
  {
    name: 'getObjectInfo',
    type: 'POST',
    path: '/get_obj_info',
    body: {
      obj: null
    }
  },
  {
    name: 'blockObject',
    type: 'POST',
    path: '/block_obj',
    body: {
      obj: null,
      op: 0
    }
  },
  {
    name: 'p11ManagerGet',
    type: 'POST',
    path: '/p11_manager_get',
    body: {
      obj: null
    }
  },
  {
    name: 'p11ManagerDel',
    type: 'POST',
    path: '/p11_manager_del',
    body: {
      obj: null,
      attrs: {}
    }
  },
  {
    name: 'p11ManagerUpdate',
    type: 'POST',
    path: '/p11_manager_update',
    body: {
      obj: null,
      attrs: {}
    }
  },
  {
    name: 'importKey',
    type: 'POST',
    path: '/key_imp',
    body: {
      obj: null,
      type: null,
      attr: null,
      mat: null
    }
  },
  {
    name: 'impKeyComponents',
    type: 'POST',
    path: '/eft_zcmk_imp',
    body: {
      type: null,
      key: null,
      part1: null,
      cks1: null,
      part2: null,
      part3: null,
      cks3: null,
      cks: null
    }
  },
  {
    name: 'importP12',
    type: 'POST',
    path: '/p12_imp',
    body: {
      key: null,
      pbk: null,
      cert: null,
      pwd: null,
      attr: null,
      pfx: null
    }
  },
  {
    name: 'importP8',
    type: 'POST',
    path: '/p8_imp',
    body: {
      obj: null,
      pwd: null,
      type: null,
      attr: null,
      pem: null
    }
  },
  {
    name: 'expKeyComponents',
    type: 'POST',
    path: '/eft_zpk_exp',
    body: {
      key: null
    }
  },
  {
    name: 'getObjectSP80057',
    type: 'POST',
    path: '/get_obj_sp80057',
    body: {
      obj: null
    }
  },
  {
    name: 'getAsymPubExp',
    type: 'POST',
    path: '/asym_pub_exp',
    body: {
      obj: null,
      x509: null
    }
  },
  {
    name: 'createKey',
    type: 'POST',
    path: '/create_key',
    body: {
      obj: null,
      type: 0,
      attr: 0
    }
  },
  {
    name: 'getMapInfo',
    type: 'POST',
    path: '/get_map_info',
    body: {
      obj: null
    }
  },
  {
    name: 'newMap',
    type: 'POST',
    path: '/new_map',
    body: {
      obj: null,
      obj1: null,
      type1: null,
      obj2: null,
      type2: null
    }
  },
  {
    name: 'setSysDate',
    type: 'POST',
    path: '/set_sys_dt',
    body: {
      day: null,
      month: null,
      year: null,
      hour: null,
      min: null,
      sec: null
    }
  },
  {
    name: 'pskcTranslate',
    type: 'POST',
    path: '/pskc_translate',
    body: {
      key: null,
      psk: null,
      pskc: null
    }
  },
  {
    name: 'renameObj',
    type: 'POST',
    path: '/rename_obj',
    body: {
      src: null,
      dst: null
    }
  },
  {
    name: 'getDSbindState',
    type: 'GET',
    path: '/get_ds_bind'
  },
  {
    name: 'bindDS',
    type: 'POST',
    path: '/ds_bind',
    body: {
      token: null
    }
  },
  {
    name: 'getCrossCheck',
    type: 'POST',
    path: '/repl_cross_check',
    body: {},
    responseRoot: 'nodes'
  },
  {
    name: 'getObjectStatistic',
    type: 'POST',
    path: '/get_obj_stat',
    body: {
      obj: null
    }
  },
  {
    name: 'getSLObjectStatistic',
    type: 'GET',
    path: '/get_sl_obj_stats'
  },
  {
    name: 'getUsrObjectCount',
    type: 'POST',
    path: '/get_usr_obj_count',
    body: {
      usr: null
    }
  },
  {
    name: 'impAesComponents',
    type: 'POST',
    path: '/eft_aes_imp',
    body: {
      type: 0,
      ckst: 0,
      attr: 0,
      key: null,
      part1: null,
      part2: null,
      part3: null,
      cks: null
    }
  },
  {
    name: 'expAesComponents',
    type: 'POST',
    path: '/eft_aes_exp',
    body: {
      ckst: 0,
      key: null
    }
  },
  {
    name: 'set_snmp_config',
    type: 'POST',
    path: '/set_snmp_config',
    body: {
      hsm_alias: '',
      community: '',
      sys_contact: '',
      sys_location: '',
      target0: '',
      target1: '',
      target3: '',
      target2: ''
    }
  },
  {
    name: 'enable_ntp',
    type: 'POST',
    path: '/enable_ntp',
    body: {
      state: 0
    }
  },
  {
    name: 'update_ntp',
    type: 'POST',
    path: '/update_ntp',
    body: {
      add: 0,
      ip: ''
    }
  },
  {
    name: 'set_dns',
    type: 'POST',
    path: '/set_dns',
    body: {
      dns0: '',
      dns1: ''
    }
  },
  {
    name: 'set_syslog_rh',
    type: 'POST',
    path: '/set_syslog_rh',
    body: {
      rhost0: '',
      rhost1: '',
      rhost2: '',
      rhost3: ''
    }
  },
  {
    name: 'bchainBip32XprvCreate',
    type: 'POST',
    path: '/bchain_bip32_xprv_create',
    body: {
      key: '',
      version: 0,
      attr: 0
    }
  },
  {
    name: 'bchain_export',
    type: 'POST',
    path: '/bchain_export',
    body: {
      key: '',
      format: 0,
      version: 0,
      compressed: 0
    }
  },
  {
    name: 'bchain_get_addr',
    type: 'POST',
    path: '/bchain_get_addr',
    body: {
      key: '',
      hrp: '',
      type: 0,
      version: 0
    }
  },
  {
    name: 'bchain_import',
    type: 'POST',
    path: '/bchain_import',
    body: {
      key: '',
      format: 0,
      attr: 0,
      data: ''
    }
  },
  {
    name: 'bchain_kinfo',
    type: 'POST',
    path: '/bchain_kinfo',
    body: {
      key: ''
    }
  },
  {
    name: 'bchain_bip32_xprv_derive',
    type: 'POST',
    path: '/bchain_bip32_xprv_derive',
    body: {
      key: '',
      dst: '',
      version: 0,
      attr: 0,
      index: 0
    }
  },
  {
    name: 'bchain_get_pbk',
    type: 'POST',
    path: '/bchain_get_pbk',
    body: {
      key: '',
      type: 0
    }
  },
  {
    name: 'bchain_hash',
    type: 'POST',
    path: '/bchain_hash',
    body: {
      data: '',
      hmode: 0
    }
  },
  {
    name: 'skeep_new_secret',
    type: 'POST',
    path: '/skeep_new_secret',
    body: {
      obj: '',
      type: 0,
      sec_level: 0
    }
  },
  {
    name: 'skeep_split_secret',
    type: 'POST',
    path: '/skeep_split_secret',
    body: {
      obj: '',
      type: 0,
      sec_level: 0,
      m: 0,
      n: 0
    }
  },
  {
    name: 'skeep_probe_secret',
    type: 'POST',
    path: '/skeep_probe_secret',
    body: {
      obj: ''
    }
  },
  {
    name: 'skeep_match_secret',
    type: 'POST',
    path: '/skeep_match_secret',
    body: {
      obj: '',
      recover: 0,
      share: []
    }
  },
  {
    name: 'skeep_del_secret',
    type: 'POST',
    path: '/skeep_del_secret',
    body: {
      obj: '',
      type: 0,
      sec_level: 0
    }
  }
]

HSM_API.forEach(method => {
  HSM.prototype[method.name] = function (args = {}) {
    const body = args.body || method.body
    const query = args.query || method.query

    return new Promise((resolve, reject) => {
      function doSort ({ data }) {
        if (Array.isArray(data) && data.length > 0) {
          return data.sort()
        }
        return data
      }

      function doPaginate ({ data, query }) {
        const response = {
          data: [],
          total: 0,
          page: 1,
          pages: 1
        }

        if (Array.isArray(data)) {
          const page = query.page
          const max = query.max
          const offset = (page - 1) * max

          response.data = data.slice(offset, offset + max)
          response.total = data.length
          response.page = page
          response.pages = Math.ceil(data.length / max)
        }

        return response
      }

      function getResponse ({
        data,
        query = {},
        sort = false,
        paginate = false
      }) {
        let response = data

        if (sort) response = doSort({ data })

        if (paginate) response = doPaginate({ data: response, query })

        return response
      }

      function sendResponse (err, res) {
        if (err) {
          const errBody = getSafe(() => err.response.body, err.message)
          return reject(errBody)
        }
        const sort = method.sort || false
        const paginate = method.paginate || false
        const responseRoot = method.responseRoot
        let body
        if (res.body[responseRoot] === null ||
          res.body[responseRoot] === undefined) {
          body = res.body
        } else body = res.body[responseRoot]

        const response = getResponse({ data: body, query, sort, paginate })

        return resolve(response)
      }

      const url = `${this.baseUrl}${method.path}`
      const isPublic = method.public
      let headers = {}

      if (this.authToken && isPublic !== true) {
        headers = { Authorization: `HSM ${this.authToken}` }
      }

      switch (method.type) {
        case 'GET':
          request
            .get(url)
            .set(headers)
            .end(sendResponse)
          break
        case 'POST':
          request
            .post(url)
            .set(headers)
            .send(body)
            .end(sendResponse)
          break
      }
    })
  }
})

export default HSM
